// extracted by mini-css-extract-plugin
module.exports = {"newsItem":"newsCard_newsItem__29QWf","newsItemTitle":"newsCard_newsItemTitle__3m4sh","newsItemDate":"newsCard_newsItemDate__1Uuv0"};